import * as types from './OrdersTypes';

export default function OrdersReducer(state, action) {
    const { type, payload } = action;

    switch (type) {
        case types.GET_ORDERS:
            return {
                ...state,
                getOrders: {
                    ...state.getOrders,
                    orders: payload.data,
                    ordersFilter: [],
                    firstOrder: payload.first,
                    lastOrder: payload.last,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.GET_ORDERS_LOADING:
            return {
                ...state,
                getOrders: {
                    ...state.getOrders,
                    loading: true
                },
            };
        case types.GET_ORDERS_ERROR:
            return {
                ...state,
                getOrders: {
                    ...state.getOrders,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.GET_ORDERS_ALL_MONTH:
            return {
                ...state,
                getOrdersAllMonth: {
                    ...state.getOrdersAllMonth,
                    orders: payload.data,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.GET_ORDERS_ALL_MONTH_LOADING:
            return {
                ...state,
                getOrdersAllMonth: {
                    ...state.getOrdersAllMonth,
                    loading: true
                },
            };
        case types.GET_ORDERS_ALL_MONTH_ERROR:
            return {
                ...state,
                getOrdersAllMonth: {
                    ...state.getOrdersAllMonth,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.GET_ORDERS_BY_ID:
            return {
                ...state,
                getOrdersById: {
                    ...state.getOrdersById,
                    order: payload,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.GET_ORDERS_BY_ID_LOADING:
            return {
                ...state,
                getOrdersById: {
                    ...state.getOrdersById,
                    loading: true
                },
            };
        case types.GET_ORDERS_BY_ID_ERROR:
            return {
                ...state,
                getOrdersById: {
                    ...state.getOrdersById,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
        case types.GET_ORDERS_FILTER:
            return {
                ...state,
                getOrders: {
                    ...state.getOrders,
                    ordersFilter: payload.data,
                    firstOrder: payload.first,
                    lastOrder: payload.last,
                    loading: false
                },
            };
        case types.GET_ORDERS_FILTER_LOADING:
            return {
                ...state,
                getOrders: {
                    ...state.getOrders,
                    loading: true
                },
            };
        case types.GET_ORDERS_FILTER_ERROR:
            return {
                ...state,
                getOrders: {
                    ...state.getOrders,
                    ordersFilter: [],
                    loading: false
                },
            };
        case types.GET_ORDERS_EXCEL:
            return {
                ...state,
                getOrdersExcel: {
                    ...state.getOrdersExcel,
                    orders: payload.data,
                    hasSuccess: true,
                    loading: false
                },
            };
        case types.GET_ORDERS_EXCEL_LOADING:
            return {
                ...state,
                getOrdersExcel: {
                    ...state.getOrdersExcel,
                    loading: true
                },
            };
        case types.GET_ORDERS_EXCEL_ERROR:
            return {
                ...state,
                getOrdersExcel: {
                    ...state.getOrdersExcel,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.GET_ORDERS_FILTER_EXCEL:
            return {
                ...state,
                getOrdersExcel: {
                    ...state.getOrdersExcel,
                    ordersFilter: payload.data,
                    hasSuccess: true,
                    loading: false
                },
            };
        case types.GET_ORDERS_FILTER_EXCEL_LOADING:
            return {
                ...state,
                getOrdersExcel: {
                    ...state.getOrdersExcel,
                    loading: true
                },
            };
        case types.GET_ORDERS_FILTER_EXCEL_ERROR:
            return {
                ...state,
                getOrdersExcel: {
                    ...state.getOrdersExcel,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.ORDERS_EXCEL_RESET_STATE:
            return {
                ...state,
                getOrdersExcel: {
                    ...state.getOrdersExcel,
                    orders: [],
                    ordersFilter: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.ORDERS_RESET_STATE:
            return {
                ...state,
                getOrders: {
                    orders: [],
                    firstOrder: null,
                    lastOrder: null,
                    ordersFilter: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                getOrdersAllMonth: {
                    orders: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
                getOrdersById: {
                    order: null,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
    
        default:
            return state;
    }
}